import { 
    Container, 
    Content,
    Title, 
    TextList } from "./styles";
import { Column } from "components/styles";
import actionImage from "img/action_image.svg";

const GuideMessage = () => {
    return (
        <Container>
            <Content>
                <img src={actionImage} alt="Imagen de decisión"/>
                <Column justifyContent="center" align="center" gap="10px">
                    <Title textAlign="center">Recuerda:</Title>
                    <TextList>
                        <li>Si deseas hacer un registro, debes desplegar el botón <b>Registrar espacio</b> y elegir la opción que desees.</li>
                        <li><b>Para cambiar la información de un espacio,</b> debes ingresar a cada campus y hacer clic en la boton editar.</li>
                    </TextList>
                </Column>
            </Content>
        </Container>
    );
}

export default GuideMessage;